/* global document */
/* eslint-disable */
import $ from 'jquery';
import 'bootstrap';
import '@babel/polyfill';
import 'es5-shim';
import GalleryLoadMore from './modules/galleryLoadmore';
import Publications from './publications';
import lightbox from './modules/lightbox';
import loadMore from './loadMore';
import AOS from 'aos';
import objectFitImages from 'object-fit-images';
import svg4everybody from 'svg4everybody';
import textTruncator from './text-truncator';
import changeLanguage from './changeLanguage';
import contactForm from './contactForm';
import filtersSticky from './filtersSticky';
import header from './header';
import animation from './animations';
import mediaGalleryFilter from './mediaGalleryFilter';
import publications from './publications';
import gallerySlider from './gallerySlider';
import challengesSlider from './challengesSlider';
import heroBannerSlider from './heroBannerSlider';
import whatWeDoneFilter from './whatWeDoneFilter';
import owlCarouselInitialization from './owlCarouselInitialization';
import newsletter from './newsletter';

let isBackend = ($('body[data-backend]').length > 0);

svg4everybody();
AOS.init({
  startEvent: 'load'
});
changeLanguage();
contactForm();
filtersSticky();
header();
animation();
mediaGalleryFilter();
publications();
gallerySlider();
if ($('.js-what-we-ve-done-filter').length == 0 || isBackend == false) {
  challengesSlider();
}
heroBannerSlider();
whatWeDoneFilter();
owlCarouselInitialization();
newsletter();

$(document).ready(function () {
  $('body').addClass('page-loaded');
  objectFitImages();
  GalleryLoadMore();
  lightbox();
  textTruncator();
  if (isBackend === false) {
    loadMore();
  }
});